import { useEffect, useState } from 'react';
import { TV_PALETTE } from './tv-mode.constants';
import { useTVScale } from './TVScaleContext';

const pad = (n: number) => String(n).padStart(2, '0');

export const TVClock = () => {
  const { s } = useTVScale();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="text-right">
      <div
        className="font-space"
        style={{
          fontWeight: 700,
          fontSize: s(32),
          lineHeight: 1,
          letterSpacing: '-0.01em',
          color: TV_PALETTE.navyDeep,
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {pad(now.getHours())}:{pad(now.getMinutes())}
        <span
          style={{ fontSize: s(20), color: TV_PALETTE.accent, marginLeft: 2 }}
        >
          {pad(now.getSeconds())}
        </span>
      </div>
      <div
        style={{
          fontSize: s(10),
          color: TV_PALETTE.textMuted,
          marginTop: 2,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
        }}
      >
        {now.toLocaleDateString('es-ES', {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
        })}
      </div>
    </div>
  );
};
